import { Cloudinary } from "@cloudinary/url-gen";
import { auto } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import { AdvancedImage } from "@cloudinary/react";

const ImageFetcher = ({ image, name, width, height }) => {
  // Your Cloudinary configuration
  const cld = new Cloudinary({ cloud: { cloudName: "dvuaaubys" } });

  // Use this sample image or upload your own via the Media Library
  let img;
  if (width || height) {
    img = cld
      .image(image)
      .format("auto") // Optimize delivery by resizing and applying auto-format and auto-quality
      .quality("auto")
      .resize(auto().gravity(autoGravity()).width(width).height(height));
  } else {
    img = cld.image(image);
  }
  return <AdvancedImage cldImg={img} className={name} />;
};

export default ImageFetcher;
